import { Component, OnInit, inject } from '@angular/core';
import { KeyValue } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { HisAuthService, GenericValue, HisNavigationService, HisBaseGlobalsService, HisTranslationService } from 'hisng';
import { PersonService } from 'app/cs/psv/common/service/person.service';
import { EMAIL_ADDRESS, PHONE_ADDRESSES, WEB_ADDRESSES } from 'app/cs/psv/common/model/person/address-constants';
import { EAddress, PsvPersonProfile } from 'app/cs/psv/common/model/person/psvPersonProfile';
import { PersonProfileEntryService } from '../../service/personprofile-entry.service';
import { PersonProfile } from '../../model/personprofile';
import { PersonProfileEntry } from '../../model/personprofile-entry';

@Component( {
    selector: 'psv-person-detail-view',
    templateUrl: './person-detail-view.component.html',
    preserveWhitespaces: false,
    standalone: false
} )
export class PersonDetailViewComponent implements OnInit {
    private hisAuthService = inject(HisAuthService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private personService = inject(PersonService);
    navigationService = inject(HisNavigationService);
    private personProfileEntryService = inject(PersonProfileEntryService);
    private hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private hisTranslationService = inject(HisTranslationService);


    public person: PsvPersonProfile;
    public showBackButton = false;
    public showSearchButton = true;
    public showEditButton = true;
    public hasEditRights: boolean = false;
    public comingFromSearchResult = false;
    public toggleContact: Array<boolean> = [];
    private sessionStorageKeyForSearchPersonUrl = 'his_cs_psv_search_person_url';
    private sessionStorageKeyForActiveMenuItem = 'listViewActiveMenuItem';
    private rightsToEditPersonProfileEntry: string[] = [
        'RIGHT_CS_PSV_PROFILE_EDIT_PROFILE',
        'RIGHT_CS_PSV_PROFILE_EDIT_PROFILE_OWN',
    ];

    search: { configFile: string; groups: any[] };

    items: any[];

    activeMenuItem: any;

    activeTabIndex: number;

    personProfile: PersonProfile;
    public showTeachingFields: boolean;
    public showResearchFields: boolean;
    public showAboutMe: boolean;
    public blockViewHeaders: string[] = [];

    public originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => 0;

    ngOnInit() {
        this.person = new PsvPersonProfile();
        this.route.queryParams.subscribe( queryParams => {
            // read parameter - back button
            this.showBackButton = queryParams['showBackButton'] === 'true' ? true : false;
            if ( queryParams['searchId'] ) {
                sessionStorage.setItem(
                    this.sessionStorageKeyForSearchPersonUrl,
                    `${location.href.split('/a/')[0]}/pages/psv/person/searchPerson.xhtml?`
                    + `_flowId=searchPerson-flow&_flowExecutionKey=${queryParams['searchId']}`
                );
            }

            this.comingFromSearchResult = queryParams['comingFromSearchResult'] === 'true'
                && !this.isEmpty(sessionStorage.getItem(this.sessionStorageKeyForSearchPersonUrl));

            if ( this.comingFromSearchResult ) {
                this.showSearchButton = false;
            }
            this.showTeachingFields = !this.hisBaseGlobalsService.getDd('cs.psv.person.profile.teachingFields')?.hidden;
            this.showResearchFields = !this.hisBaseGlobalsService.getDd('cs.psv.person.profile.researchFields')?.hidden;
            this.showAboutMe = !this.hisBaseGlobalsService.getDd('cs.psv.person.profile.aboutMe')?.hidden;
            if( this.showAboutMe ) { this.blockViewHeaders.push('cs.psv.person.profile.aboutMe.header'); }
            if( this.showResearchFields ) { this.blockViewHeaders.push('cs.psv.person.profile.researchField.header'); }
            if( this.showTeachingFields ) { this.blockViewHeaders.push('cs.psv.person.profile.teachingField.header'); }
        });

        this.route.params.subscribe( params => {
            this.personService.getPersonProfileByPersonId( parseInt( params['personId'], 10 ) ).subscribe( p => {
                this.person = p;
                this.setListviewItems(p.extendedData);
                let sessionActiveMenuItem = sessionStorage.getItem(this.sessionStorageKeyForActiveMenuItem);
                if( sessionActiveMenuItem ) {
                    this.setMenuItemById(sessionActiveMenuItem);
                    sessionStorage.removeItem(this.sessionStorageKeyForActiveMenuItem);
                }

                this.personProfileEntryService.canEditProfile(p.id).subscribe((rightResult) => { this.hasEditRights = rightResult; });
            } );
        } );
    }

    setListviewItems(extendedData: any) {
        let setMenuItem = ( event: any ) => this.setMenuItemById(event.item.id);

        this.items = [{ id: 'overview', icon: 'APPLICATION', tabIndex: 0, command: setMenuItem }];
        let tabIndexCount = 1;

        extendedData.listViews.forEach((lv: string) => {
            if(extendedData[lv] != null && extendedData[lv].totalCount > 0) {
                this.items.push({id: lv, extendedData, icon: extendedData[lv].icon, tabIndex: tabIndexCount, command: setMenuItem });
                tabIndexCount++;
            }
        });

        if (tabIndexCount===1) {
            // Es gibt nur den Tab 'Übersicht'. Der muss dann aber leer sein, und deshalb entfernen wir ihn auch.
            this.items=[];
        } else if (tabIndexCount===2) {
            // Es gibt nur den Tab 'Übersicht' und einen anderen Tab.
            // Dann hat die Übersicht denselben Inhalt wie der andere Tab, und daher entfernen wir die Übersicht.
            this.items.splice(0,1);
            this.items[0].tabIndex = 0;
            this.activeMenuItem = this.items[0];
            this.setMenuItemById(this.activeMenuItem.id);
        } else {
            // Es gibt die Übersicht und mindestens zwei andere Tabs
            this.activeMenuItem = this.items[0];
        }
    }

    onBeforeSetActiveItem() {
        if (this.activeTabIndex >= 0) {
            this.setMenuItemById(this.items[this.activeTabIndex].id);
            sessionStorage.setItem(this.sessionStorageKeyForActiveMenuItem, this.activeMenuItem.id);
        }
    }

    setMenuItemById(itemId: string) {
        if (this.items.find(i => i.id === itemId) !=null ){
            this.activeMenuItem = this.items.find(i => i.id === itemId);
            this.activeTabIndex = this.activeMenuItem.tabIndex;
            if (this.activeMenuItem?.id !== 'overview') {
                let filterSplit = this.activeMenuItem.extendedData[itemId].searchQueryParams.objectIdFilter.split('&');
                let fieldValue: {field: string; value: string }[] = [];
                filterSplit.forEach((element: any) => {
                    fieldValue.push({field: element.split('=')[0], value: element.split('=')[1]});
                });

                this.search = {
                    configFile: this.activeMenuItem.extendedData[itemId].searchQueryParams.configFile,
                    groups: [{criteria: fieldValue }]
                };
            }
        }
    }

    // return the url of the current window
    getUrl() {
        return window.location.href;
    }
    // get the Full name of person including titles and degrees according to PSV specifications
    getFullPersonNameAndTitle() {
        return this.person.personCompleteName;
    }

    isPersonCompletNameLoaded(): boolean {
	 return (this.getFullPersonNameAndTitle() !== null &&
              this.getFullPersonNameAndTitle() !== undefined) ? true : false;
    }

    isEmpty( input: any ): boolean {
        return _.isNil( input ) || _.isEmpty( input );
    }

    isPrefixTitle() {
        return this.person.academicdegree.positionOfTitle === 0;
    }

    // getter ------------------------------------------------------------------------------------------
    getPersonId(): number {
        return this.person.id;
    }

    getEAddressTypeMail( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return address.type.hiskeyId === EMAIL_ADDRESS;
        } );
    }

    getEAddressTypePhone( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return PHONE_ADDRESSES.indexOf( address.type.hiskeyId ) > -1;
        } );
    }

    getEAddressTypeWeb( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return WEB_ADDRESSES.indexOf( address.type.hiskeyId ) > -1;
        } );
    }

    toggleContactDataForAffiliation( toggle: boolean, id: number ) {
        this.toggleContact[id] = toggle;
    }

    backToPersonSearchResult() {
        window.location.href = sessionStorage.getItem(this.sessionStorageKeyForSearchPersonUrl);
    }

    public getResearchAreaQueryParams(researchArea: GenericValue, isKdsf?: boolean): any {
        let isEmploymentClassifications: boolean = this.hisBaseGlobalsService.conf['core.psv.person.profile.person_profile_classification_data_source_is_employment'];
        let researchAreaType = isKdsf ? 'kdsf' : 'hochschuleigen';
        let queryParams = this.getBaseSearchQueryParams(isEmploymentClassifications);
        if (isEmploymentClassifications) {
            queryParams['Employment.researchAreas{researchAreaType="' + researchAreaType + '"}.defaulttext[]'] = researchArea.defaulttext;
        } else {
            queryParams['Person:PersonResearchArea{REVERSEPATH=person}.abstractResearchAreaValue{researchAreaType="' + researchAreaType + '"}.defaulttext[]'] = researchArea.defaulttext;
        }
        return queryParams;
    }

    public getSubjectAreaQueryParams(subjectArea: GenericValue): any {
        let isEmploymentClassifications: boolean = this.hisBaseGlobalsService.conf['core.psv.person.profile.person_profile_classification_data_source_is_employment'];
        let queryParams = this.getBaseSearchQueryParams(isEmploymentClassifications);
        if (isEmploymentClassifications) {
            queryParams['Employment.subjectAreas.defaulttext[]'] = subjectArea.defaulttext;
        } else {
            queryParams['Person:PersonSubjectArea{REVERSEPATH=person}.subjectAreaValue.defaulttext[]'] = subjectArea.defaulttext;
        }
        return queryParams;
    }

    private getBaseSearchQueryParams(isEmploymentClassifications: boolean): any {
        let classificationSource: string = isEmploymentClassifications ? 'Employment' : 'Person';
        return {
            configFile: 'cs/psv/searchPersonsBy' + classificationSource + 'Classifications.xml',
            pageTitle: 'de.his.javang.suchen.personen.titel',
            tableTitle: 'de.his.javang.gefunden.personen',
            showBackButton: true,
        };
    }

    public edit() {
        let personId = this.person.id;
        if (personId === this.hisAuthService.personId) {
            const menuUrl =
                location.href.split( '/a/' )[0] +
                '/pages/cs/sys/portal/subMenu.faces' +
                '?navigationPosition=userinformation%2CpersonalSettings';
            window.location.href = menuUrl;
            this.navigationService.setLastBackUrl(menuUrl);
        } else {
            // wenn personId != auth.personId, dann nicht ins Menü sondern direkt zur Bearbeitungsseite springen
            this.navigationService.setLastBackUrl(window.location.href);
            this.router.navigate(['/person/edit/' + personId], { queryParams: { showBackButton: true } });
        }
    }

    public findProfileEntry( entryValueHiskeyId: number ) {
        return this.person.extendedData?.personProfileEntries?.find((e:any) => e.personProfileEntryValue?.hiskeyId === entryValueHiskeyId);
    }

    public translateText( hisobject: PersonProfileEntry, hisAttribute: string ) {
        return hisobject ? this.hisTranslationService.translate(hisobject, hisAttribute) : '';
    }

    get blockViewHeader(): string[] {
        return this.blockViewHeaders;
    }

    get blockViewObjects(): any[] {
        let blockViewObjects = [];
        if ( this.showAboutMe ) {
            blockViewObjects.push(this.findProfileEntry(1003));
        }
        if ( this.showResearchFields ) {
            blockViewObjects.push(this.findProfileEntry(1002));
        }
        if ( this.showTeachingFields ) {
            blockViewObjects.push(this.findProfileEntry(1001));
        }
        return blockViewObjects;
    }

    public onBeforeNavigate() {
        this.navigationService.setLastBackUrl(window.location.href);
    }
}
